@if (loginError()) {
  <app-alert alertType="error">
    {{ 'login.errors.generic_login_error'| translate }}
  </app-alert>
}
